import type { RespondentFilterUsingMetaGroupsProps } from './RespondentFilterUsingMetaGroups';

type MetaGroups = RespondentFilterUsingMetaGroupsProps['metaGroups'];

export function countRespondentsInMetaGroups(metaGroups: MetaGroups): number {
    return metaGroups.reduce(
        (answerCount, metaGroup) => answerCount + metaGroup.answerCount,
        0,
    );
}
